import Vue from 'vue'
import CONFIG from '~config/env'
import _ from 'lodash'

export default {
  getUserNames: (state, getters) => ids => {
    if (!state.users) return []
    const names = _.map(ids, id => {
      const user = state.users.find(user => user.id === id)
      if (user) return user.name
    })

    if (names.length === 2) {
      return names.join(' ' + getters.i18nString('and') + ' ')
    } else if (names.length > 2) {
      return names.slice(0, names.length - 1).join(', ') + ' ' + getters.i18nString('and') + ' ' + names[names.length - 1]
    } else {
      return names[0]
    }
  },
  getUsers: state => ids => {
    if (!state.users) return []
    return _.map(ids, id => {
      return state.users.find(user => user.id === id) || {}
    })
  },
  getUserName: state => id => {
    if (!state.users) return ''
    const user = state.users.find(user => user.id === id)
    if (user) return user.name
  },
  getUser: state => id => {
    if (!state.users) return {}
    return state.users.find(user => user.id === id) || {}
  },
  users_getter: (state, getters) => {
    return state.users
      .map(user => {
        const userClone = _.cloneDeep(user)
        userClone.role_i18n = [getters.i18nString(userClone.userOrganizations?.nodes?.[0]?.role)]
        userClone.role = String(userClone.userOrganizations?.nodes?.[0]?.role).toLowerCase()
        userClone.textualId = `${user.name}#${user.id}`
        return userClone
      })
      .filter(user => {
        return user.email !== 'staff@staff.com'
      })
  },
  pendingInvites_i18n: (state, getters) => {
    return _.filter(state.invites, invite => {
      return invite.accepted_at === null
    }).map(invite => {
      const inviteClone = _.cloneDeep(invite)
      inviteClone._role_i18n = getters.i18nString(inviteClone.role)
      inviteClone._send_at = Vue.moment.utc(inviteClone.created_at).local().format('LLL')
      return inviteClone
    })
  },
  roles_i18n: (state, getters) => {
    return _.map(CONFIG.USER_ROLES, role => {
      return {
        name: role,
        name_i18n: getters.i18nString(role)
      }
    })
  },
  selectedProjectMembers(state, getters, rootState) {
    const projectId = rootState.projectsModule.selectedProject.id
    return state.users
      .filter(user => {
        const projectMember = !!user.userProfiles?.nodes?.find(userProfile => {
          return userProfile.projectId === projectId
        })

        const admin = !!user.userOrganizations?.nodes?.find(userOrganization => {
          return userOrganization.role === 'ADMIN'
        })
        return projectMember || admin
      })
      .map(user => {
        return {
          ...user,
          projectProfile: user.userProfiles?.nodes?.find(userProfile => {
            return userProfile.projectId === projectId
          })
        }
      })
  }
}
